export const getProperHref = (href: string) => (href?.startsWith('http') ? href : `http://${href}`)
